import * as React from 'react';
export var GridContext = React.createContext({
  spacing: undefined
});